import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MaterialEntry } from '../models/material-entry.model';
import { CreatePurchaseDto } from '../models/dtos/createPurchase.dto';
import { RestResponse } from '../models/restResponse.mode';
import { PaginatedList } from '../models/paginatedList.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialEntryService {
  private readonly baseUrl = `${environment.base_url}/purchases`;

  constructor(private http: HttpClient) {}

  list(search: string = '', page: number = 1): Observable<RestResponse<PaginatedList<MaterialEntry[]>>> {
    const params: any = { page };
    if (search) params.search = search;
    return this.http.get<RestResponse<PaginatedList<MaterialEntry[]>>>(`${this.baseUrl}/list`, { params });
  }

  getById(id: number): Observable<RestResponse<MaterialEntry>> {
    return this.http.get<RestResponse<MaterialEntry>>(`${this.baseUrl}/find/${id}`);
  }

  create(payload: CreatePurchaseDto): Observable<RestResponse<MaterialEntry>> {
    return this.http.post<RestResponse<MaterialEntry>>(`${this.baseUrl}/create`, payload);
  }

  update(id: number, entry: Partial<MaterialEntry>): Observable<RestResponse<MaterialEntry>> {
    return this.http.put<RestResponse<MaterialEntry>>(`${this.baseUrl}/update/${id}`, entry);
  }
}
